/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const UserEditPage = () => {
  const params = useParams();

  const { getUserEditData, postUserEditData } = useContext(AdminContext);
  const [selected, setSelected] = useState();
  const [name, setName] = useState("");
  const [userData, setUserData] = useState(null);
  const [surname, setSurname] = useState("");
  const [pharmacies, setPharmacies] = useState(null);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const selectHandler = (el) => {
    setSelected(el.target.value);
  };

  const nameHandler = (el) => {
    setName(el.target.value);
  };

  const surnameHandler = (el) => {
    setSurname(el.target.value);
  };

  const closeSuccess = () => {
    setSuccess(null);
  };

  const submitHandler = (el) => {
    el.preventDefault();
    setSuccess(null);
    setError(null);
    postUserEditData(userData.id, name, surname, selected).then((res) => {
      if (res.status === 200) {
        setSuccess(res.data);
      } else {
        setError(res.response.data.message);
      }
    });
  };

  useEffect(() => {
    getUserEditData(params.user_id).then((res) => {
      if (res.status === 200) {
        setName(res.data.u.name);
        setSurname(res.data.u.surname);
        setUserData(res.data.u);
        setSelected(res.data.u.num_ap);
        setPharmacies(res.data.pharmacies);
        document.title =
          "Пользователь " + res.data.u.surname + " " + res.data.u.name;
      } else {
        setError(res.response.data.message);
      }
    });
  }, []);
  return (
    <section className="login">
      <div className="container">
        <div className="admin__user">
          <ButtonBack />
        </div>
        <h1 className="login__text">Редактирование</h1>

        <div className="login__wrapper">
          {!pharmacies ? (
            <div style={{ height: 410 }}>
              <CoveredBackground>
                <Loader />
              </CoveredBackground>
            </div>
          ) : (
            <form className="login__form" onSubmit={submitHandler}>
              {error && <ErrorMessage message={error} />}
              <div className="login__item">
                <label htmlFor="name">Имя:</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  name="name"
                  className="login__input"
                  placeholder="Имя"
                  autoComplete="off"
                  onInput={nameHandler}
                  required
                />
              </div>
              <div className="login__item">
                <label htmlFor="surname">Фамилия:</label>
                <input
                  type="text"
                  id="surname"
                  value={surname}
                  name="surname"
                  className="login__input"
                  placeholder="Фамилия"
                  onInput={surnameHandler}
                  autoComplete="off"
                  required
                />
              </div>

              <div className="login__item">
                <label htmlFor="num_ap">Номер аптеки:</label>
                <select
                  id="num_ap"
                  name="num_ap"
                  className="login__input"
                  value={selected}
                  required
                  onChange={selectHandler}
                >
                  {pharmacies.map((ph) => (
                    <option value={ph.num} key={ph.num}>
                      {" "}
                      {ph.short_name}
                    </option>
                  ))}
                </select>
              </div>

              <button className="login__wrapper__link" style={{ fontSize: 29 }}>
                Сохранить
              </button>
            </form>
          )}
        </div>
      </div>
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </section>
  );
};

export default UserEditPage;
